import React, { Component } from "react";

import { connect } from "react-redux";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import ApplicatedQuestionList from "../../../../components/ApplicatedQuestionList/ApplicatedQuestionList";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ActivityShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      listQuestion: {
        id: "",
        show: false,
        average: 0
      }
    };
  }

  // eslint-disable-next-line camelcase
  async UNSAFE_componentWillMount() {
    const { id } = this.props.match.params;
    this.props.setObj(19, id, this.props.currentRoute);
    const [activityTypeGet, activityGet] = await Promise.all([
      axios.get(`${URL.api}content/type/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      }),
      axios.get(`${URL.api}activity/activity/singleView/${id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
    ]);

    const evaluationItem = activityGet.data.data.items.find(
      item => item.type_id === 12
    );

    this.setState({
      activity: activityGet.data.data,
      evaluation: evaluationItem
        ? {
            ...evaluationItem,
            title: evaluationItem.name,
            subtitle: evaluationItem.type_name,
            obj_id: evaluationItem.obj_id
          }
        : null,
      loading: false
    });
  }

  render() {
    return (
      <div id="list" className="animated fadeIn">
        <Breadcrumb
          current={this.props.currentRoute}
          // items={[{ path: "/evaluation/list", to: "/evaluation/list" }]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <React.Fragment>
            {!this.state.loading && (
              <ApplicatedQuestionList
                activityId={this.state.activity.id}
                currentRoute={this.props.currentRoute}
                // allocation_id={this.state.allocation_id}
                id={this.state?.evaluation?.obj_id}
                history={this.props.history}
                prototype
                item_id={this.state.item_id}
                // execution_id={this.state.execution_id}
                result_type={this.state.activity.result_type}
                ended={false}
                close={() =>
                  this.setState(
                    {
                      listQuestion: {
                        // eslint-disable-next-line react/no-access-state-in-setstate
                        id: this.state.listQuestion.id,
                        show: false
                      }
                    },
                    () => this.handleActivity()
                  )
                }
                end_date={this.state.activity.activity_end}
              />
            )}
            <ProtectedRoute routeId={this.props.currentRoute} />
          </React.Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityShow);
